import React from "react";
import { Link } from "react-router-dom";

export default function VoteList({
  index,
  display_account,
  create_time,
  voteId,
  name,
  point,
  code,
}) {
  return (
    <React.Fragment>
      <tr>
        <td>
          <div style={{ display: "flex", alignItems: "center" }}>
            <img src={`/images/Detail/${code}.png`} alt={name} />
            <div>{name}</div>
          </div>
        </td>
        <td>
          {point} ⭐️
        </td>
        <td>
          <Link to={`/phieu-binh-chon/${voteId}`} className="link">
            {voteId}
          </Link>
        </td>
        <td>
          <Link to={`/nguoi-binh-chon/${display_account}`} className="link">
            {display_account}
          </Link>
        </td>
        <td>{create_time}</td>
      </tr>
    </React.Fragment>
  );
}
